import Syncable from '@/syncing/Syncable.js'
import { canViewRegionsHelper } from '@/composables/permissionHelper.js'
import { useRegionStore } from '@/store/regions.js'
import { isBarnPrecondition, isInstanceNotStalePrecondition, isLoggedInPrecondition, isOnlinePrecondition } from '@/syncing/SyncablePreconditions.js'
import { computed } from 'vue'

class RegionsSyncable extends Syncable {
  constructor(globalUniqueIdentifier) {
    super(globalUniqueIdentifier, 1000 * 60 * 30, [
      isBarnPrecondition,
      isOnlinePrecondition,
      isLoggedInPrecondition,
      guid => computed(() => canViewRegionsHelper(guid)),
      isInstanceNotStalePrecondition,
    ])
  }

  hasInitialData() {
    return !!useRegionStore().getRegionTypes(this.globalUniqueIdentifier)
  }

  async workload() {
    await useRegionStore().loadRegionSetup(this.globalUniqueIdentifier, true)
  }
  static getSyncableHandle() {
    return 'regions'
  }
}

export default RegionsSyncable
